import ReactDOM from "react-dom";
import React from "react";
import DiseaseFundDetail from "../components/disease-fund-detail/DiseaseFundDetail";

const init = () => {
  let mountPoint = document.querySelector("#DiseaseFundDetail");

  if (mountPoint) {
    const title = mountPoint.getAttribute("data-title");
    const groupId = mountPoint.getAttribute("data-group-id");
    const jumpLink = mountPoint.getAttribute("data-jump-link");
    let jumpLinks = [];
    try {
      const raw = JSON.parse(mountPoint.getAttribute("data-jump-links") || "[]");
      jumpLinks = Array.isArray(raw) ? raw : Object.values(raw || {});
    } catch (e) {
      console.warn("Invalid data-jump-links JSON:", e);
      jumpLinks = [];
    }
    // add this near your other getAttribute lines
    let jumpLinkAnchors = [];
    try {
      jumpLinkAnchors = JSON.parse(
        mountPoint.getAttribute("data-jump-link-anchors") || "[]"
      );
    } catch (e) {
      console.warn("Invalid data-jump-link-anchors JSON:", e);
      jumpLinkAnchors = [];
    }
    const grantType = mountPoint.getAttribute("data-grant-type");

    let eligibilityItems = [];
    try {
      eligibilityItems = JSON.parse(
        mountPoint.getAttribute("data-eligibility-items") || "[]"
      );
    } catch (e) {
      console.warn("Invalid data-eligibility-items JSON:", e);
      eligibilityItems = [];
    }

    const eligibilityCriteria = mountPoint.getAttribute(
      "data-eligibility-criteria"
    );
    const assistanceAmount = mountPoint.getAttribute("data-assistance-amount");
    const fundIntroTitle = mountPoint.getAttribute("data-fund-intro-title");
    const fundIntro = JSON.parse(mountPoint.getAttribute("data-fund-intro"));
    const eligibilityChecklistTitle = mountPoint.getAttribute("data-eligibility-checklist-title");
    const additionalAssistanceAmountInformation = mountPoint.getAttribute("data-additional-assistance-amount-information");
    const additionalDiseaseInformation = mountPoint.getAttribute("data-additional-disease-information");
    const medicationsHeading = mountPoint.getAttribute("data-medications-title");
    const medicationsContent = JSON.parse(mountPoint.getAttribute("data-medications-content"));

    /* parse optional data attributes for potential maintenance message*/
    const maintenance = mountPoint.getAttribute("data-maintenance");
    const maintenanceMessageLine1 = mountPoint.getAttribute(
      "data-maintenance-message-line-1"
    );
    const maintenanceMessageLine2 = mountPoint.getAttribute(
      "data-maintenance-message-line-2"
    );

    ReactDOM.render(
      <DiseaseFundDetail
        jumpLink={jumpLink}
        title={title}
        groupId={groupId}
        eligibilityCriteria={eligibilityCriteria}
        maintenance={maintenance}
        maintenanceMessageLine1={maintenanceMessageLine1}
        maintenanceMessageLine2={maintenanceMessageLine2}
        jumpLinks={jumpLinks}
        jumpLinkAnchors={jumpLinkAnchors}
        grantType={grantType}
        assistanceAmount={assistanceAmount}
        fundIntroTitle={fundIntroTitle}
        fundIntro={fundIntro}
        eligibilityChecklistTitle={eligibilityChecklistTitle}
        eligibilityItems={eligibilityItems}
        medicationsHeading={medicationsHeading}
        medicationsContent={medicationsContent}
        additionalAssistanceAmountInformation={additionalAssistanceAmountInformation}
        additionalDiseaseInformation={additionalDiseaseInformation}
      />,
      mountPoint
    );
  }
};

// Init on initial page load
init();
